<template>
  <section>
    <Navbar />
    <Hero />
    <About />
    <Video />
    <!-- <Yellow /> -->
    <Lyrics />
    <Food />
    <!-- <Faqs /> -->
    <Footer />
  </section>
</template>

<script>
import Navbar from "../components/Navbar.vue";
// import Faqs from "../components/Faqs.vue";
import Footer from "../components/Footer.vue";
import Hero from "../components/Hero.vue";
import Video from "../components/Video.vue";
import Food from "../components/Food.vue";
// import Yellow from "../components/Yellow.vue";
import Lyrics from "../components/Lyrics.vue";
import About from "../components/About.vue";

export default {
  name: "MainPage",
  components: {
    Navbar,
    Footer,
    // Faqs,
    Hero,
    Video,
    Food,
    // Yellow,
    Lyrics,
    About,
  },
  props: {
    locality: {
      type: String,
      default: "",
      required: true,
    },
  },
};
</script>

<style lang="scss">
$desktop: 1440px;
$tablet: 768px;
$mobile: 600px;

.orange {
  background: var(--color-orange-1);
}

.grey {
  background: #EFEDEA;
}
.pink {
  background: #F2A6B0;
}
.yellow {
  background: #F6C243;
}
.hide {
  display: none;
}

.white-button {
  background: white;
  border-radius: 800px;
  padding: 10px 24px;

  font-size: 20px;
  line-height: 28px;
  font-family: 'jet-bold';
  color: #242E30;
  display: block;
  text-align: center;

  &:hover {
    color: #242E30;
  }
}
.container {
  max-width: 895px;
  margin: 0 auto;

  @media (max-width: $tablet) {
    padding: 0 15px;
  }
}

.mycontent {
  position: relative;
  width: 100%;
  max-width: 1220px;
  margin: 0 auto;
}

.columns {
  padding-left: 0rem;
  padding-right: 0rem;
}
.row {
  margin-left: 0.83333rem;
  margin-right: 0.83333rem;
  width: auto;
}
.noPadding {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.pageContainer {
  position: relative;
  overflow-x: hidden;
}

.vAligner {
  display: flex;
  align-items:  center;
  justify-content: center;

}
.aligner {
  display: flex;
  align-items: center;
  justify-content: center;
}

.razor-up-grey {
  position: relative;
}
.razor-up-grey:before {
  content: "";
  position: absolute;
  z-index: -1;
  right: 0;
  left: 0;
  top: -14vw;
  margin: 0 auto;
  width: 100%;
  height: 14vw;
  overflow: hidden;
  clip-path: polygon(0 100%, 100% 100%, 100% 0);
  -webkit-clip-path: polygon(0 100%, 100% 100%, 100% 0);
  background: #EFEDEA;
}

/* ################# */
/* ################# */
/* MEDIA QUERIES */

@media only screen and (max-width :1280px){

.mycontentTop {
  padding: 0 16px;
}

}




@media only screen and (max-width :1024px){

/* START LANG MENU */


.select-menu {
  background: #f8f5f2;
  z-index: 1006;
  position: fixed;
  overflow-y: scroll;
  overflow-x: hidden;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin-top: 0;
  border-radius: 0px;
  padding: 90px 16px 16px;

  width: 100%;
  min-width: 100%;
  min-height: 100%;

  cursor: pointer;
  transform: none;
  box-shadow: 0 3px 8px 0 rgba(0,0,0,.05);
}
.select-menu:before {
  content: '';
  position: absolute;
  background: #ff8000;
  left: 0;
  top: 0;
  height: 72px;
  width: 100%;
  display: block;
}
.select-menu .title {
  display: none;
}
.select-menu .menu-title {
  display: block;
}
.select-menu .close:hover {
  -webkit-transform: rotate(360deg);
  transform: rotate(360deg);
}

.mycontentTop {
  left: inherit;
  transform: none;
}

.list-container {
  background: #fff;
  float: left;
  padding: 16px 24px;
  width: 100%;
  min-width: 100%;
  border-radius: 5px;
}

/* END LANG MENU */

}



@media only screen and (max-width :1023px){

h2 {
  font-size: 26px;
  line-height: 34px;
}
h4 {
  font-size: 16px;
  line-height: 24px;
}


.welcome {
  z-index: 0;
  position: relative;
  display: block;
  margin: 0 auto;
  padding: 24px 0 0;
}
.welcome h1 {
  padding: 0 0 0;
  font-size: 36px;
  line-height: 44px;
  text-align: center;
  max-widtH: 700px;
  margin: 0 auto;
}
.welcome h2 {
  margin: 0 auto;
  padding: 14px 0 24px;
  font-size: 26px;
  line-height: 34px;
  text-align: center;
}
.welcome p {
  max-width: 600px;
  padding: 0 0 30px;
  margin: 0 auto;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
}
.welcome-logo {
  width: 100%;
  margin: 0 auto 30px auto !important;
  max-width: 270px;
}
.welcome .columns img {
  margin: 0;
}



.welcome .vAligner, .lyrics .vAligner {
  display: contents;
}

.welcome-dish {
  max-width: 400px;
  margin: 0 auto !important;
}

.how {
  padding: 0 15px 200px;
}
.how h4 {
  margin: 90px 0 40px;
  padding: 0 20%;
  font-size: 16px;
  line-height: 26px;
}
.how .mycontent .maintitle p {
  font-size: 14px;
}



.lyrics .row {
  display: flex;
  flex-direction: column-reverse;
}
.lyrics .mycontent {
  position: relative;
  overflow: hidden;
}
.content-section {
  padding: 50px 30px;
}
.content-section p {
  font-size: 14px;
}
.content-section p span {
  position: relative;
  display: none;
  height: 0;

  -webkit-transition: all 0.7s ease-In-Out;
  transition: all 0.7s ease-In-Out;
}
.content-section p.visible span {
  display: block;
  height: 100%;
}
.content-section p:after {
  content: "";
  display: block;
  z-index: 989;
  opacity: 1;
  cursor: pointer;
  width: .8em;
  height: .8em;
  left: calc(50% - 0.4em);
  top: calc(50% - 0.2em);
  transition: 0.3s;
  margin: 0 auto;
  border-right: 2px solid #fff;
  border-top: 2px solid #fff;
  transform: rotate(495deg);

  -webkit-transition: all 0.3s ease-In-Out;
  transition: all 0.3s ease-In-Out;
}
.content-section p.visible:after {
  margin-top: 30px;
  transform: rotate(-45deg);
}




/*
.focus {
  top: -340px;
}
.focus .vAligner {
  margin: 0 15px;
}
.focus .vAligner {
  display: block;
}
.focus .row {
  margin: 0;
}
.focus h2 {
  margin-bottom: 30px;
  text-align: center;
}
.focus p {
  font-size: 14px;
  text-align: center;
}
.focus .columns:first-of-type {
  padding: 30px 20px 70px;
}
.focus .columns:last-of-type img {
  max-width: 90%;
  margin: 0 auto;
  margin-top: -40px;
  padding-bottom: 40px;
}
*/
.devider {
  display: block;
  height: 15px;
}

}



@media only screen and (max-width :800px){

h2 {
  padding: 0;
}


.how {
  padding: 0 15px 200px;
}
.how .mycontent .maintitle {
  margin-bottom: 0;
}


ul.usp {
  font-size: 14px;
}
ul.usp li {
  background-size: 15px 15px;
  padding-left: 34px;
  margin-top: 24px;
}

}



@media only screen and (max-width :768px){

h3 {
  font-size: 24px;
  line-height: 32px;
}

}



@media only screen and (max-width :640px){

.logo {
  display: none;
}
.logo-mob {
  display: block;
}
.topBar-nav .custom-button {
  top: 2px;
  min-width: 120px;
  margin: 0 20px;
  padding: 10px 30px;
  font-size: 14px;
}

.welcome-logo {
  max-width: 250px;
}

.item-content p {
  max-width: 250px;
}

.video-play {
  width: 80px;
  height: auto;
}

.content-section {
  padding: 50px 15px;
}

.how h4 {
  margin: 90px 0 40px;
  padding: 0;
  font-size: 16px;
  line-height: 26px;
}

}



@media only screen and (max-width :520px){

.welcome-logo {
  width: 100%;
  margin: 30px 0 10px;
}

}



@media only screen and (max-width :480px){

h1 {
  padding: 16px 20px 24px 20px;
}

.custom-button {
  min-width: 240px;
  padding: 10px 10px;
  font-size: 16px;
}

}



@media only screen and (max-width :420px){

.item {
  width: 100%;
  margin: 0 1% 80px 1%;
  cursor: pointer;
  -webkit-transition: all 0.3s ease-In-Out;
  transition: all 0.3s ease-In-Out;
}

.video-play {
  width: 76px;
  height: auto;
}

}




@media only screen and (max-width :370px){

h1 {
  padding: 8px 16px 8px 16px;
  font-size: 28px;
  line-height: 28px;
}
h1.smaller {
  font-size: 28px;
  line-height: 28px;
}

.custom-button {
  font-size: 14px;
}

}


</style>